import React from 'react'
import styled, { css } from 'styled-components'

import sindyCatMegafonImage from 'assets/sindy_cat_megafon.png'

interface NotificationToggleButtonProps {
  onClick: () => void
  badgeCount?: number
  isOpen?: boolean
}

export const NotificationToggleButton: React.FC<
  NotificationToggleButtonProps
> = ({ onClick, badgeCount = 0, isOpen = false }) => {
  return (
    <ToggleButton
      onClick={onClick}
      $isOpen={isOpen}
      $hasUnread={badgeCount > 0}
    >
      <ButtonImage src={sindyCatMegafonImage} alt='Notifications' />
      {badgeCount > 0 && (
        <Badge $count={badgeCount}>
          {badgeCount > 99 ? '99+' : badgeCount}
        </Badge>
      )}
    </ToggleButton>
  )
}

const ToggleButton = styled.button<{ $isOpen: boolean; $hasUnread: boolean }>`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${({ theme }) => theme.shadows.menu};
  transition: all 0.3s ease;
  z-index: ${({ theme }) => theme.zIndex.modal + 50};
  padding: 0;
  overflow: visible;

  &:hover {
    transform: scale(1.05);
    box-shadow: ${({ theme }) => theme.shadows.menu},
      0 4px 12px rgba(129, 79, 153, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }

  ${({ $isOpen, theme }) =>
    $isOpen &&
    css`
      border-color: ${theme.colors.primary};
    `}

  ${({ $hasUnread }) =>
    $hasUnread &&
    css`
      animation: shake 5s ease-in-out infinite;
    `}

  @keyframes shake {
    0%,
    10%,
    100% {
      transform: translateX(0) rotate(0deg);
    }
    1%,
    3%,
    5%,
    7%,
    9% {
      transform: translateX(-3px) rotate(-2deg);
    }
    2%,
    4%,
    6%,
    8% {
      transform: translateX(3px) rotate(2deg);
    }
  }
`

const ButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
`

const Badge = styled.div<{ $count: number }>`
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: rgb(222, 60, 243);
  color: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  border: 2px solid ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`